<template>
  <div>
    <div class="wrap ad-box">
      <a-row :gutter="16">
        <a-col :span="12" v-if="ad[0]">
          <img :src="$store.state.assetUrl + ad[0].img" alt="">
        </a-col>
        <a-col :span="12" v-if="ad[1]">
          <img :src="$store.state.assetUrl + ad[1].img" alt="">
        </a-col>
      </a-row>
    </div>
    <div class="page-container wrap">
        <div class="warning-notic" v-if="!$store.state.authInfo.account.id" @click="$router.push('/dashboard/commission')">
          请完善您的收款账户，去完善 >>
          <!-- <span class="close-btn" @click.stop="warningVisible = false"><a-icon type="close-circle"  /></span> -->
        </div>
        
        <div class="layout-wrap">
          <div class="menu-box">
            
            <div class="item" v-for="(item, i) in $store.state.menus" :key="i" :class="{active:currentMenuIndex == i}" @click="goPage(item.route, i)">
              <a-icon :type="item.icon"></a-icon>
              {{item.label}}
            </div>
            
            <div class="bottom-box">
              
              <div class="nickname-box" @click="showNicknameForm">
                <span class="nickname" >{{$store.state.authInfo.nickname}}</span>
                <a-icon type="edit"></a-icon>
                <div class="tips">将在用户确认订单时显示<br>【来自xxx的专属优惠】</div>
              </div>
              <div class="password-box" @click="showPasswordForm">
                 <a-icon type="lock"></a-icon><span class="label">修改密码</span> 
              </div>
            </div>
          </div>
          <div class="page-content">
             <router-view></router-view>
          </div>
        </div>

        <a-modal v-model="nicknameVisible" :title="null" :closable="null" width="330px" centered>
          <div slot="footer"  class="white-wrap">
            <a-button type="default" @click="nicknameVisible = false" shape="round">
              返回
            </a-button>
            <a-button key="submit" type="primary"  @click="saveNickname" shape="round">
              确认
            </a-button>
          </div>
        <div class="white-wrap">
          <div class="nickname-edit-tips">
            昵称将会在用户确认订单时显示
            <div class="tips">【来自xxx的专属优惠】</div>  
          </div>
          <a-input v-model="nickname"></a-input>
        </div>
      </a-modal>
      <a-modal v-model="passwordVisible" title="修改密码" :closable="null" width="330px" centered>
          <div slot="footer" class="white-wrap">
            <a-button type="default" @click="passwordVisible = false" shape="round">
              取消
            </a-button>
            <a-button key="submit" type="primary"  @click="savePassword" shape="round">
              确认
            </a-button>
          </div>
        <div class="white-wrap">
          <a-form-item label="新密码">
            <a-input v-model="password" type="password" placeholder="请输入您的密码"></a-input>
          </a-form-item>
          <a-form-item label="确认密码">
            <a-input v-model="confirm_password" type="password" placeholder="请再输入一次密码"></a-input>
          </a-form-item>
        </div>
      </a-modal>
       
    </div>
  </div>
</template>

<script>
let self;
export default {
  name: '',
  data(){
    return {
      currentMenuIndex:0,
      nicknameVisible:false,
      nickname:'',
      passwordVisible:false,
      password:'',
      confirm_password:'',
      ad:[]
    }
  },
  watch:{
    $route(to){
      this.setMenuIndex(to.path);
    }
  },
  mounted(){
    self = this;
    this.setMenuIndex(this.$route.path);
    this.getAdInfo();
  },
  methods:{
    getAdInfo(){
      this.$http.get('getAdInfo').then((res)=>{
        self.ad = res.data;
      })
    },
    goPage(route){
      this.$router.push('/dashboard' + route);
    },
    setMenuIndex(path){
      this.$store.state.menus.map((v,i)=>{
        if(path == '/dashboard'){
          self.currentMenuIndex = 0;
        }else if('/dashboard' + v.route == path){
          self.currentMenuIndex = i;
        }
      });
    },
    showNicknameForm(){
      this.nickname = this.$store.state.authInfo.nickname;
      this.nicknameVisible = true;
    },
    saveNickname(){
      this.$http.post('saveNickname',{nickname:this.nickname}).then((res)=>{
        self.nicknameVisible = false;
        self.$helper.setStorage('union-auth-info', res.data);
        self.$store.dispatch('initAuthInfo');
      });
    },
    showPasswordForm(){
      this.password = '';
      this.confirm_password = '';
      this.passwordVisible = true;
    },
    savePassword(){
      this.$http.post('savePassword',{password:this.password, confirm_password: this.confirm_password}).then((res)=>{
        self.passwordVisible = false;
        self.$message.success(res.msg);
      });
    }
  }
}
</script>
<style>
.transpanret-table .ant-table-placeholder{
  background: transparent;
  border-top: none;
}
.transpanret-table .ant-table-thead > tr > th{
  background: rgba(255, 255, 255, 0.05);
  border-bottom:none
}
.transpanret-table .ant-table-tbody > tr > td{
  border-bottom:1px solid rgba(255, 255, 255, 0.03)
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import '../assets/reset.less';
  .page-container{
    min-height: 600px;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .ad-box{
    margin: 20px auto;
    height: 100px;
    overflow: hidden;
  }
  .ad-box img{
    border-radius: 10px;
    width: 100%;
    height: 97px;
  }
  .warning-notic{
    background: @error-color;
    color: #fff;
    padding: 1rem;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
  }
  .warning-notic:active{
    background: rgba(255, 62, 104, 0.8);
  }
  .warning-notic .close-btn{
    position: absolute;
    right: 1rem;
    top: 1rem;
    color: #fff;
  }

  .layout-wrap{
    display: flex;
    margin-top: 20px;
    height: 100%;
  }
  .layout-wrap .menu-box{
    width: 220px;
    color: #fff;
    background: #222338;
    border-radius: 5px;
    border: 1px solid #222;
    overflow: hidden;
    height: 100%;
    min-height:720px;
    position: relative;
  }
  .layout-wrap .menu-box>.item{
    padding: 1.5rem 1rem;
    color: #717483;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
  }
  .layout-wrap .menu-box>.item:hover{
    color: rgba(255, 255, 255, 0.6);
  }
  .layout-wrap .menu-box>.item.item.active::before{
    content: '';
    display: block;
    width: 4px;
    height: 24px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    background: #524793;
    box-shadow: 0 0 5px #524793;
    position: absolute;
    left: 0;
    top: calc(50% - 12px);
  }
  .layout-wrap .menu-box .item.active{
    color: rgba(255, 255, 255, 1);
  }
  .layout-wrap .menu-box .item .anticon{
    margin-right: 10px;
  }
  
  .page-content{
    padding-left: 30px;
    width: 980px;
  }

  .bottom-box{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
  }
  .nickname-box{
    position: relative;
    padding: 1rem;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.2s;
    border-top: 1px dashed rgba(255, 255, 255, 0.3);
  }
  .nickname-box::before{
    content:'';
    display: block;
    position: absolute;
    height: 10px;
    width: 10px;
    background: @success-color;
    border-radius: 50%;
    box-shadow: 0 0 10px @success-color;
    left: 20px;
    top: 22px;
  }

  .nickname-box:hover{
    color: #fff;
  }

  .nickname-box .nickname{
    padding-left: 25px;
    margin-right: 10px;
  }
  .nickname-box .tips{
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 10px;
  }
  .nickname-edit-tips{
    
    text-align: center;
    margin-bottom: 20px;
  }
  .nickname-edit-tips .tips{
    font-size: 16px;
    color: #111;
  }

  .password-box{
    padding: 10px;
    position: relative;
    color: rgba(255, 255, 255, 0.65);
    background: rgba(255, 255, 255, 0.03);
  }
  .password-box .label{
    padding-left: 15px;
    margin-right: 10px;
    
    cursor: pointer;
  }
  .password-box:hover{
    color: #fff;
  }
</style>
